export const GREMLIN_COM_DOCS_LINKS = {
  AWS_AUTO_SCALING_GROUPS_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks#toc-auto-scaling-group-asg-with-policies',
  AWS_LOAD_BALANCER_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks#toc-aws-detected-risks',
  AZURE_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks#toc-azure-detected-risks',
  GCP_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks#toc-gcp-detected-risks',
  RELEASE_NOTES_GENERAL: 'https://www.gremlin.com/release-notes/general',
  RM_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks',
  RM_SPOF:
    'https://www.gremlin.com/docs/reliability-management-dependencies#toc-marking-a-dependency-as-a-single-point-of-failure-spof',
  ROUTING_HEALTH_CHECKS:
    'https://www.gremlin.com/docs/platform-health-checks#toc-routing-health-checks-to-specific-pni-agents'
}
